import * as React from 'react';
import { EntityTypeCountIcon } from '../entities/entity-type-count-icon';
export var defaultEntityTypeCountIconsSet = {
  Entity: EntityTypeCountIcon
};
export var EntityTypeCountIconsContext = React.createContext(defaultEntityTypeCountIconsSet);
export var EntityTypeCountIconsProvider = EntityTypeCountIconsContext.Provider;
export var useEntityTypeCountIcons = function () {
  return React.useContext(EntityTypeCountIconsContext);
};
export var useEntityTypeCountIcon = function (entityTypeName) {
  var icons = useEntityTypeCountIcons();
  return icons[entityTypeName] || EntityTypeCountIcon;
};